module.exports = __webpack_public_path__ + "img/3.42e75b4a.png";